var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.911848 7.74152C2.96766 6.60915 5.26251 5.66401 7.40669 4.71407C11.0955 3.15814 14.799 1.62917 18.5399 0.205721C19.2677 -0.0368065 20.5755 -0.273955 20.7037 0.804616C20.6335 2.33138 20.3446 3.84921 20.1465 5.36704C19.6436 8.70489 19.0624 12.0313 18.4956 15.3582C18.3003 16.4663 16.9121 17.04 16.0239 16.3308C13.8892 14.8889 11.7381 13.461 9.63074 11.9857C8.94041 11.2843 9.58056 10.2769 10.1971 9.77601C11.9553 8.04334 13.8198 6.57124 15.4861 4.74902C15.9356 3.66365 14.6075 4.57836 14.1695 4.85866C11.7625 6.51733 9.41447 8.27726 6.8768 9.735C5.58055 10.4485 4.06976 9.83877 2.7741 9.44062C1.61241 8.95963 -0.0899459 8.47503 0.91173 7.74166L0.911848 7.74152Z",
    fill: "#363870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b64325fb4ec8eef9013d2202e59dc699.svg";
export { ForwardRef as ReactComponent };